'use client';

import { useFrame, useThree } from '@react-three/fiber';
import { demoteNestedTransmission } from './camera-env-link';
import {
  ensureTransmissionFrontCullHooks,
  installTransmissionPassTracker,
  restoreStuckTransmissionWriteState,
  updateTransmissionCullState,
} from './transmission-front-cull';

/**
 * Nested glass/liquid demotion + exclude surface-mounted trim from the
 * transmission refraction buffer (glued cage ribs must not ghost inside glass).
 *
 * Priority -2: after GlbModel material enforcement (−1).
 */
export function NestedTransmissionApplier() {
  const scene = useThree((s) => s.scene);
  const gl = useThree((s) => s.gl);

  useFrame(() => {
    installTransmissionPassTracker(gl);
    restoreStuckTransmissionWriteState(scene);
    demoteNestedTransmission(scene);
    updateTransmissionCullState(scene);
    ensureTransmissionFrontCullHooks(scene);
  }, -2);

  return null;
}
